import { SelectedFilters } from '../filters-store/filters-store';

export const filterKeys = {
  all: () => ['filters'],
  search: (filters: SelectedFilters) => ['filters', filters],
};
